import React, {useContext} from "react";
import {Stage} from "../../../api/model/scenario";
import {ScenarioContext} from "../../../contexts/ScenarioContext";
import {StepComponent} from "../Step";
import {Response, saveQuotation} from "../../../api/quotationApiClient";
import {QuotationContext} from "../../../contexts/QuotationContext";
import {Quotation} from "../../../model/quotation";
import {ErrorMessageDialog} from "../../dialogs/ErrorMessageDialog";
import {handleAfterStepErrors} from "../error-handlers";
import * as log from "../../../utils/log";
import {useErrorDialog} from "../../../utils/hooks/useErrorDialog";
import {ProcessingContext} from "../../../contexts/ProcessingContext";
import {getFuncMod} from "../../../utils/log";

interface StageComponentProps {
    stage: Stage;
}

export const StageComponent = ({stage}: StageComponentProps) => {
    const {currentStep, setCurrentStep, setPreviousStep, nextStageHandler, popPreviousQuotationStepCode,
        pushPreviousQuotationStepCode, setStepMessages} = useContext(ScenarioContext);
    const {setQuotation, type} = useContext(QuotationContext);
    const {setProcessingOpen} = useContext(ProcessingContext);

    const {
        textErrorMessageDialog,
        openErrorMessageDialog,
        textDetailErrorMessageDialog,
        errorDialogType,
        hide
    } = useErrorDialog();


    const nextStepHandler = (quotation: Quotation) => {
        const date = new Date();
        const currentStepIndex = stage.steps.indexOf(currentStep);
        pushPreviousQuotationStepCode(quotation.currentStep);
        quotation.currentStep = currentStep.code;
        quotation.admitadId = getCookie("_aid");
        quotation.salesDoublerId = getCookie("sd_user");
        setProcessingOpen(true);
        saveQuotation(quotation, type).then((response: Response) => {

            if (response.success) {
                if (response.data.messageList && response.data.messageList.length > 0) {
                    const messages = response.data.messageList.map(messagesData => messagesData.message)
                    setStepMessages(messages);
                    response.data.messageList = [];
                }

                setQuotation(response.data);
                setProcessingOpen(false);
                setPreviousStep(currentStep);
                if (stage.steps.length === currentStepIndex + 1) {
                    nextStageHandler(response.data)
                } else {
                    setCurrentStep(stage.steps[currentStepIndex + 1]);
                }

                window.scrollTo(0, 0);
            } else {
                handleAfterStepErrors(response);
                log.sendLog(date, getFuncMod(type), 'ERROR', "SAVE_QUOTATION", [{"quotation": quotation}], response.errorResponse.text);
            }
        });
    };

    const getCookie = (name: string): string | undefined => {
        const regex = new RegExp(
            `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`
        );
        const matches = regex.exec(document.cookie);
        return matches ? decodeURIComponent(matches[1]) : undefined;
    };

    const backStepHandler = (quotation: Quotation, stepCallback?: (stage: Stage) => void) => {
        const currentStepIndex = stage.steps.indexOf(currentStep);
        setPreviousStep(currentStep);
        setCurrentStep(stage.steps[currentStepIndex - 1]);
        quotation.currentStep = popPreviousQuotationStepCode();
        setQuotation(quotation);

        if (stepCallback) {
            stepCallback(stage);
        }

        window.scrollTo(0, 0);
    };

    return (
        <div className={'stage'}>
            <StepComponent step={currentStep}
                           nextStepHandler={nextStepHandler}
                           backStepHandler={backStepHandler}/>

            <ErrorMessageDialog type={errorDialogType}
                                text={textErrorMessageDialog}
                                open={openErrorMessageDialog}
                                onClickListener={hide}
                                textDetail={textDetailErrorMessageDialog}/>
        </div>
    )
}
